import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorPage from '../../../../common/src/components/ErrorPage';
import LoadingScreen from '../../../../common/src/components/LoadingScreen';
import { useCompleteConversation } from '../../../../conversations/src/features/detail/shared/api/completeConversation';
import AdvisoryAppShell from '../../../../flows/src/components/ui/advisory-flow/components/app-shell/AdvisoryAppShell';
import useSessionId from '../../../../flows/src/hooks/useSessionId';
import FinalizePageContent from '../../features/finalize/FinalizePageContent';

const VillasureFinalize: React.FC = () => {
  const { t } = useTranslation();
  const sessionId = useSessionId();
  const { mutate, data, isLoading, isIdle, isError } = useCompleteConversation(
    sessionId,
    false,
  );

  useEffect(() => {
    if (isIdle) mutate(undefined);
  }, []);

  if (isError)
    return (
      <AdvisoryAppShell>
        <ErrorPage />
      </AdvisoryAppShell>
    );

  if (isLoading || !data)
    return (
      <AdvisoryAppShell>
        <LoadingScreen />
      </AdvisoryAppShell>
    );

  if (data.remarks?.customer_is_insured)
    return (
      <FinalizePageContent
        title={t('SALES-CONVERSATION_PIA_FINALIZE_TITLE_INSURED')}
        description={t('SALES-CONVERSATION_PIA_FINALIZE_DESCRIPTION_INSURED')}
      />
    );

  return (
    <FinalizePageContent
      title={t('SALES-CONVERSATION_PIA_FINALIZE_TITLE_REQUESTED')}
      description={t('SALES-CONVERSATION_PIA_FINALIZE_DESCRIPTION_REQUESTED', {
        riskObject: t('FLOWS_TOOLBAR_RESIDENCE').toLowerCase(),
      })}
    />
  );
};

export default VillasureFinalize;
